import { render, staticRenderFns } from "./BaseNav.vue?vue&type=template&id=f3b5f4dc&"
import script from "./BaseNav.vue?vue&type=script&lang=js&"
export * from "./BaseNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3b5f4dc')) {
      api.createRecord('f3b5f4dc', component.options)
    } else {
      api.reload('f3b5f4dc', component.options)
    }
    module.hot.accept("./BaseNav.vue?vue&type=template&id=f3b5f4dc&", function () {
      api.rerender('f3b5f4dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseNav.vue"
export default component.exports